import { useMutation } from '@tanstack/react-query';
import { createDevice, refreshDeviceToken, updateDevice, updateDeviceName } from '@/api/devices';
import {
	CreateDeviceRequest,
	UpdateDeviceNameRequest,
	UpdateDeviceRequest,
} from '@/api/devices/types';
import { MutationRequest } from '@/api/types';
import { UseMutationQueryParams } from './types';

export const useCreateDevice = (mutationQueryParams: UseMutationQueryParams) =>
	useMutation({
		mutationFn: ({ request, formKey }: MutationRequest<CreateDeviceRequest>) =>
			createDevice({ request, formKey }),
		...mutationQueryParams,
	});

export const useUpdateDevice = (mutationQueryParams: UseMutationQueryParams) =>
	useMutation({
		mutationFn: ({ id, request }: { id: string; request: MutationRequest<UpdateDeviceRequest> }) =>
			updateDevice(id, request),
		...mutationQueryParams,
	});

export const useUpdateDeviceName = (mutationQueryParams: UseMutationQueryParams) =>
	useMutation({
		mutationFn: ({
			id,
			request,
		}: {
			id: string;
			request: MutationRequest<UpdateDeviceNameRequest>;
		}) => updateDeviceName(id, request),
		...mutationQueryParams,
	});

export const useRefreshDeviceToken = (mutationQueryParams: UseMutationQueryParams) =>
	useMutation({
		mutationFn: ({ id }: { id: string }) => refreshDeviceToken(id),
		...mutationQueryParams,
	});
